import { api, setConfig, UPDATE_GAME_MESSAGE } from '../..';
import { PropertyType } from '../../../common';

export const unassignGamePartners = async (data: PropertyType): Promise<PropertyType> => {
	try {
		await api.post('/games/partners/unassign', data, setConfig(data));
		return { message: UPDATE_GAME_MESSAGE };
	} catch (error: any) {
		const apiError = error.response?.data?.errors?.error?.[0] || '';
		throw new Error(apiError);
	}
};
